import React, {useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom'
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import RecetteMensuelle from './pages/RecetteMensuelle';
import Recette from './pages/Recette';
import { useTranslation } from 'react-i18next';
import Depense from './pages/Depense';
import DepenseMensuelle from './pages/DepenseMensuelle';
import Indicateurs from './pages/Indicateurs';
import Msis from './pages/Msis';
import Municipalite from './pages/Municipalite';
function App () {
 
 
  
  
  const bootstrapCSS = document.getElementById("bootstrapCSS");
  const styleCSS = document.getElementById("styleCSS");
  const responsiveCSS = document.getElementById("responsiveCSS");
  const treeGridCSS = document.getElementById("treeGridCSS");
  const themeCSS = document.getElementById("themeCSS");


  const { t } = useTranslation();

  
  useEffect(() => {
		
   

     bootstrapCSS.href=t('bootstrapCSS');
     styleCSS.href=t('styleCSS');
     responsiveCSS.href=t('responsiveCSS');
     treeGridCSS.href=t('treeGridCSS');
     themeCSS.href=t('themeCSS');
	  

	  
	}, [t,bootstrapCSS,styleCSS,responsiveCSS,treeGridCSS,themeCSS]);
  
  
   
  return (
    <Router>
      <div className="App">

        < Header />
       
            <Routes>
              <Route exact path='/msis' element={<Msis />} />
              <Route exact path='/municipalite' element={<Municipalite />} />
              <Route exact path='/' element={<Home />} />
              <Route exact path='/recette' element={<Recette />} />
              <Route exact path='/recette_mensuelle' element={<RecetteMensuelle />} />
              <Route exact path='/depense' element={<Depense />} />
              <Route exact path='/depense_mensuelle' element={<DepenseMensuelle />} />
              <Route exact path='/indicateurs' element={<Indicateurs />} />
              
            </Routes>

        < Footer />


      </div>
    </Router>
  )

}

export default App;
